export type AnalyticsConsentStatus = 'granted' | 'denied';

export const COOKIE_CONSENT_STORAGE_KEY = 'sunmarbella_cookie_consent_v1';
export const COOKIE_CONSENT_EVENT = 'sunmarbella:cookie-consent-updated';
export const OPEN_COOKIE_PREFERENCES_EVENT = 'sunmarbella:open-cookie-preferences';

export function getAnalyticsConsentStatus(): AnalyticsConsentStatus | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const value = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
  return value === 'granted' || value === 'denied' ? value : null;
}

export function hasAnalyticsConsent(): boolean {
  return getAnalyticsConsentStatus() === 'granted';
}

export function setAnalyticsConsentStatus(status: AnalyticsConsentStatus): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, status);
  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_EVENT, {
      detail: status,
    })
  );
}

export function openCookiePreferences(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}
